import React, { useState } from "react";
import Admin from '../super_components/Admin.js';
import Teacher from '../super_components/Teacher.js';
import Student from '../super_components/Student.js';
import SignIn from '../super_components/SignIn.js';
import '../styles.css';

function App(props) {
  const [userRole, setUserRole] = useState('');
  const [userData, setUserData] = useState([]);
  const teacherLogin = () => {
    setUserRole("teacher")
  }

  const studentLogin = () => {
    setUserRole("student")
  }

  const adminLogin = () => {
    setUserRole("admin")
  }

  const logout = () => {
    setUserRole("")
  }

  if (userRole === "student") {
    return <Student identification={userData} func={logout} />
  }

  else if (userRole === "teacher") {
    return <Teacher identification={userData} func={logout} />

  }

  else if (userRole === "admin") {
    return <Admin identification={userData} func={logout} />
  }

  else {
    return <SignIn admin={adminLogin} teacher={teacherLogin} student={studentLogin} setUserData={setUserData} />
  }
}

export default App;